const TRADE_OPTIONS = {
    TRADE_PURCHASE: 1,
    SELL_VEHICLE: 2,
    NOT_SURE: 3,
};

const TRADE_OPTIONS_KEY = {
    1: 'TRADE_ON_PURCHASE',
    2: 'SELL_VEHICLE',
    3: 'NOT_SURE',
};

export default TRADE_OPTIONS;
export { TRADE_OPTIONS_KEY };
